import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

const partsIssueWarningGroup = {
  componentType: LayoutTypes.FIELD_GROUP,
  Label:
    "Parts issue is pending or partially issued. Spare parts on this job card have not been fully issued. Tick the checkbox below to close without completing parts issue.",
  BindValue: "con_parts_issue_warning",
  HideOnStates: ["Closed"],
  ShowWhen: {
    field: "issue_status",
    values: [
      "Pending",
      "Partially Issued",
      "Partially issued",
      "Not Issued",
    ],
    ignoreCase: true,
  },
  style: {
    direction: FlexDirection.COLUMN,
    gap: 8,
    padding: 12,
    borderRadius: 8,
    backgroundColor: "#FEF2F2",
  },
  childComponents: [
    {
      componentType: ComponentType.CHECKBOX,
      name: "chk_force_close_without_parts_issue",
      Label: "Close without completing parts issue",
      BindValue: "chk_force_close_without_parts_issue",
      Json_Attribute: "force_close_without_parts_issue",
    },
  ],
};

export const screen_39_close_jobcard: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Close job",
    BindValue: "con_vehicle_approval",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "job_approval_add",
        columnNumber: "m1 t1 w1",
        TableName: "service_job_approval",
        DisplayName: "Job Approval",
        Workflow: "service",
        DisableSubmit: true,
        BindValue: "job_approve_add",
        SubmitActions: [
          {
            Action: "Navigate",
            Navigate: "modulev1/vehicleinsummary",
          },
        ],
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          padding: 16,
          borderRadius: 12,
        },
        Fields: [
          {
            componentType: LayoutTypes.GROUP,
            Label: "",
            BindValue: "cont_Action",
            style: {
              direction: FlexDirection.ROW,
              padding: 0,
              margin: 0,
              marginBottom: 16,
              gap: 8,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "lock",
                Label: "lock",
                BindValue: "lock",
                onPressAction: "unlock",
                ScreenId: "39",
                ActionType: "Unlock",
                LockBinding: true,
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 8,
                  borderRadius: 4,
                  fontSize: 14,
                },
              },
            ],
          },
          {
            componentType: LayoutTypes.FIELD_GROUP,
            Label: "",
            BindValue: "con_approval_details",
            style: {
              direction: FlexDirection.COLUMN,
              gap: 16,
            },
            childComponents: [
              {
                IncludeLabel: true,
                Label: "VIN No.",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "parentid",
                Json_Attribute: "parent_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                showInSummary: false,
                AutoSelect: "parentid",
                IsReadOnly: true,
                LookupName: "close_job_no",
                IsVerticalView: true,
              },
              {
                IncludeLabel: true,
                Label: "Status",
                PlaceHolder: "",
                BindValue: "job_close_status",
                Json_Attribute: "job_close_status",
                componentType: ComponentType.SELECT_DROPDOWN,
                showInSummary: false,
                options: [{ label: "Closed", value: "Closed" }],
                LookupName: "Close",
                IsMandatory: true,
                IsVerticalView: true,
                HideOnStates: ["Closed"],
              },
              {
                IncludeLabel: true,
                Label: "Parts issue",
                BindValue: "issue_status",
                Json_Attribute: "issue_status",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: true,
                excludeFromSave: true,
                HideOnStates: ["Closed"],
                BindParent: {
                  parentid: "issue_status",
                },
              },
              partsIssueWarningGroup,
              {
                Label: "",
                BindValue: "qc_details",
                componentType: ComponentType.REPORT,
                IncludeLabel: true,
                Settings: "close_job_card",
                Parent_Field: "parentid",
              },
            ],
          },
        ],
      },
      {
        componentType: ComponentType.BUTTON,
        name: "Submit",
        Label: "Submit",
        BindValue: "btn_submit",
        onPressAction: "save",
        ActionType: "Add",
        ScreenId: "39",
        next_action: "Close",
        next_state: "Closed",
        Enabled: {
          Enable: {
            Json_Attribute: "current_state",
            values: [
              "Estimated",
              "Jobcard",
              "Approved",
              "Rejected",
              "Put on hold",
            ],
          },
          Mode: ["Edit", "Add"],
        },
        HideOnStates: ["Closed"],
        style: {
          textColor: "#FFFFFF",
          padding: 8,
          borderRadius: 4,
          fontSize: 14,
        },
      },
    ],
  },
];
